import { defineComponent as _defineComponent } from 'vue'
import { ContentLoader } from '@tencent/wphk-components-content-loader';
import Container from './container.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'module-skeleton',
  setup(__props) {


return { __sfc: true,ContentLoader, Container }
}

})